/**
 *
 * MobileTeacherHeader
 *
 */

import React, {
  useRef,
  useEffect,
  useCallback,
} from "react";

import {useTranslation} from "react-i18next";
import classNames from "classnames";

// styles
import "./style.scss";

// antd component
// import { Button } from 'antd';
// import { NavBar } from 'antd-mobile';

// components
import TCFModal from "components/TCFModal";

// contexts
import { withTheme } from "engine/Contexts/Theme.context";

function ModalOnSaveChanges({
  // default props
  placement,
  message,
  title,
  okText,
  cancelText,
  closable,
  // actions
  onCancel,
  onConfirm,
  // contexts
  theme,
  // default props
  children,
  className,
}) {
  const {t} = useTranslation();
  const containerRef = useRef(null);

  const childClassNames = classNames("tcf-odal-on-save-changes", className);

  useEffect(() => {
    return () => {};
  }, []);

  const cancelHandler = useCallback(() => {
    !!theme?.isOpenModalOnSaveChanges &&
      (theme?.useAdd({
        isOpenModalOnSaveChanges: false,
        canceledModalOnSaveChanges: true,
        savedModalOnSaveChanges: false,
        hasValueModalOnSaveChanges: false,
      }),
      !!onCancel && onCancel());
  }, [
    theme?.isOpenModalOnSaveChanges,
    theme?.hasValueModalOnSaveChanges,
    onCancel,
  ]);
  const saveHandler = useCallback(() => {
    !!theme?.isOpenModalOnSaveChanges &&
      !!theme?.hasValueModalOnSaveChanges &&
      (theme?.useAdd({
        isOpenModalOnSaveChanges: false,
        hasValueModalOnSaveChanges: false,
        canceledModalOnSaveChanges: false,
        savedModalOnSaveChanges: true,
      }),
      !!onConfirm && onConfirm());
  }, [
    theme?.isOpenModalOnSaveChanges,
    theme?.hasValueModalOnSaveChanges.onConfirm,
  ]);
  const openHandler = useCallback(() => {
    !!theme?.isOpenModalOnSaveChanges &&
      !!theme?.hasValueModalOnSaveChanges &&
      (theme?.useAdd({
        isOpenModalOnSaveChanges: true,
        hasValueModalOnSaveChanges: true,
        canceledModalOnSaveChanges: false,
        savedModalOnSaveChanges: false,
      }),
      !!onConfirm && onConfirm());
  }, [
    theme?.isOpenModalOnSaveChanges,
    theme?.hasValueModalOnSaveChanges.onConfirm,
  ]);

  return (
    <TCFModal
      open={theme?.isOpenModalOnSaveChanges}
      setOpen={state => openHandler(state)}
      title={!!title && title || t("common.renderPopconfirmMessage")}
      onCancel={cancelHandler}
      onOk={saveHandler}
      cancelName={!!cancelText && cancelText || t("common.no")}
      submitName={!!okText && okText || t("common.yes")}
      closable={closable}
      wrapClassName={childClassNames}
    >
      {message || children}
    </TCFModal>
  );
}

ModalOnSaveChanges.defaultProps = {
  visibility: false,
  placement: "top",
  message: "",
  closable: false,
};

export default withTheme(ModalOnSaveChanges);
